// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Container {
  position: relative;
  width: 100%;
}

.Label {
  display: block;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--text-color);
  padding-left: 0.5rem;
}

.InputOverwrite {
  box-sizing: border-box;
  width: 100%;
  background-color: var(--primary-color);
  border: 1px solid transparent;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
  border-radius: 0.375rem;
  transition: all 150ms ease-in-out;
  cursor: pointer;
  border-color: var(--border-color);
}
.InputOverwrite::placeholder {
  color: var(--text-color);
}
.InputOverwrite:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(39, 128, 253, 0.3);
  border-color: var(--border-color-dark);
}

.OptionContainer {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  z-index: 10;
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  background-color: var(--secondary-color);
  filter: brightness(1.3);
  margin-top: 0.4rem;
  padding-top: 0.75rem;
  padding-right: 1rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  max-height: 240px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
}
.OptionContainer > ul {
  padding: 0px;
  margin: 0px;
}

.OptionContainer > ul > li {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.OptionContainer > ul > li:hover {
  background-color: var(--primary-color-light);
  color: var(--text-color);
  cursor: pointer;
}

.combobox-icon {
  padding-right: 10px;
  height: 16px;
  width: 16px;
}`, "",{"version":3,"sources":["webpack://./src/client/HoosatUI/src/Elements/Form/Combobox/Combobox.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,wCAAwC;EACxC,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,4CAA4C;EAC5C,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb","sourcesContent":["@import '../../../theme.css';\n\n.Container {\n  position: relative;\n  width: 100%;\n}\n\n.Label {\n  display: block;\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: var(--text-color);\n  padding-left: 0.5rem;\n}\n\n.InputOverwrite {\n  box-sizing: border-box;\n  width: 100%;\n  background-color: var(--primary-color);\n  border: 1px solid transparent;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  border-radius: 0.375rem;\n  transition: all 150ms ease-in-out;\n  cursor: pointer;\n  border-color: var(--border-color);\n}\n.InputOverwrite::placeholder {\n  color: var(--text-color);\n}\n.InputOverwrite:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(39, 128, 253, 0.3);\n  border-color: var(--border-color-dark);\n}\n\n.OptionContainer {\n  box-sizing: border-box;\n  width: 100%;\n  position: absolute;\n  z-index: 10;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: block;\n  background-color: var(--secondary-color);\n  filter: brightness(1.3);\n  margin-top: 0.4rem;\n  padding-top: 0.75rem;\n  padding-right: 1rem;\n  padding-bottom: 0.75rem;\n  padding-left: 1rem;\n  max-height: 240px;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n}\n.OptionContainer > ul {\n  padding: 0px;\n  margin: 0px;\n}\n\n.OptionContainer > ul > li {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.OptionContainer > ul > li:hover {\n  background-color: var(--primary-color-light);\n  color: var(--text-color);\n  cursor: pointer;\n}\n\n.combobox-icon {\n  padding-right: 10px;\n  height: 16px;\n  width: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
